import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class AdquirenteService {

  constructor(
    private http: HttpClient
  ) { }

  adicionar(data) {
    return this.http
      .post(urls.apiBase + '/Adquirentes/Adicionar', data);
  }

  atualizar(data) {
    return this.http
      .put(urls.apiBase + '/Adquirentes/Atualizar', data);
  }

  remover(id) {
    return this.http
      .delete(urls.apiBase + '/Adquirentes/Remover?id=' + id);
  }

  obterPorContaId(id) {
    return this.http
      .get(urls.apiBase + '/Adquirentes/ObterPorContaId?contaId=' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/adquirente/adquirente.service.ts